import { Routes, Route, BrowserRouter } from "react-router-dom"

import { Home } from "./pages/Home"

import { ScrollTop } from './components/ScrollTop'

import './App.scss'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <ScrollTop />
    </div>
  )
}

export default App
